const Style = ({ isMobile }) => `
  <style>
    .frequency-buttons-container {
      display: flex;
      gap: 8px;
    }

    .frequency-button {
      padding: 16px;
      border-radius: 11px;
      border: 1px solid #E6E8E8;
      background: white;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: ${isMobile ? '95px;' : '240px;'}
      height: 84px;
      position: relative;
    }

    .frequency-button.selected {
      border: 1px solid #8AE5D3;
      background: #F1F9F7;
    }

    .frequency-button-number {
      display: block;
      font-size: 18px !important;
      line-height: 22px;
    }
    .recommended-container {
      border-radius: 11px 11px 0 0;
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
    .recommended-frequency {
      background-color: #D2EAE5
    }
    .events-none {
      pointer-events: none;
    }
    .frequency-text {
      margin-top: 10px;
    }

    .featured-option {
      height: 100px;
      margin-top: -16px
    }

    .featured-option .content-wrapper{
      margin-top: 25px;
    }

    .frequency-span {
      ${isMobile ? '' : 'width: 280px;'}
      text-align: center;
      visibility: hidden;
    }
  </style>`;

export default Style;
